import { isDev } from 'static/script/utils/environment';

const getCookieNameForEnvironment = name => (isDev() ? `${name}_test` : name);

export const AUTH_ACCESS_TOKEN_COOKIE_NAME = getCookieNameForEnvironment(
    'trd_at'
);
export const AUTH_REFRESH_TOKEN_COOKIE_NAME = getCookieNameForEnvironment(
    'trd_rt'
);
export const AUTH_PERSIST_COOKIE_NAME = getCookieNameForEnvironment('trd_rk');

export const mightBeLoggedIn = req =>
    Boolean(req.cookies[AUTH_REFRESH_TOKEN_COOKIE_NAME]);

export const addCookie = (res, cookie) => {
    const previouslySetCookies = res.getHeader('Set-Cookie');
    if (Array.isArray(previouslySetCookies)) {
        res.setHeader('Set-Cookie', [...previouslySetCookies, cookie]);
    } else if (previouslySetCookies) {
        res.setHeader('Set-Cookie', [previouslySetCookies, cookie]);
    } else {
        res.setHeader('Set-Cookie', cookie);
    }
};
